import { render, staticRenderFns } from "./QrCode.vue?vue&type=template&id=c06c248a&scoped=true"
import script from "./QrCode.vue?vue&type=script&lang=js"
export * from "./QrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06c248a",
  null
  
)

export default component.exports